import React from 'react';
import {getImageUrl} from "../util";
import ButtonComponent from "./ButtonComponent";

export default ({title, subtitle, imageFetchId, friendlyName, onCardClick}) => {
    let imageCss = imageFetchId !== null  ? 'url(' + getImageUrl(imageFetchId) + ')' : 'none';

    let style = {
        backgroundImage: imageCss
    };

    return <div style={style}
                onClick={onCardClick}
                className="reward-card-content clickable"
                data-tms-event="card-click-impression"
                data-tms-card-zone="myReward – deals overview"
                data-tms-card-name={friendlyName}>
        <h3 className="reward-title">{title}</h3>
        <h6 className="reward-subtitle" dangerouslySetInnerHTML={{__html: subtitle.replace(/(?:\r\n|\r|\n)/g, '<br/>')}}/>
        <ButtonComponent textKey="rewards.detailButton" className="default-btn reward-detail-btn" />
    </div>
}